import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import cx from 'classnames'

import { SharingNativeMobile } from 'components/SharingNativeMobile/SharingNativeMobile'
import content from 'prismic-translates/common.json'
import { useAppSelector } from 'store/hooks'
import { getUserCustomerIdSelector } from 'store/modules/user/selectors'
import { useThemeContext } from 'theme/themeProvider'
import { generateShareUlrWithUserId } from 'utils/url'

import ReferFriendCopyButton from './components/ReferFriendCopyButton'
import ReferFriendsQRCode from './components/ReferFriendQRCode'
import classes from './styles.module.scss'

export default function ReferFriendsLink({ shareMessage = '' }: { shareMessage: string }) {
  const customerId = useAppSelector(getUserCustomerIdSelector)
  const shareUrl = generateShareUlrWithUserId(customerId)
  const { isDarkMode } = useThemeContext()
  const t = getTranslationFromJson([content])
  const normalizedUrl = shareUrl.startsWith('http') ? shareUrl : `https://${shareUrl}`

  return (
    <>
      <div className={cx(classes.root, isDarkMode && classes.rootDarkMode)} data-test='invite-friends-native-copy'>
        <div className={classes.container}>
          <p className={cx(classes.title, isDarkMode && classes.titleDarkMode)}>{t('your_unique_invite_link')}</p>
          <span className={classes.shareUrl} data-testid='invite-link'>
            {normalizedUrl}
          </span>
          <div className={classes.shareWrapper}>
            <SharingNativeMobile dataTestId='share-button' text={`${shareMessage} \n${normalizedUrl}`} />
            <ReferFriendCopyButton shareUrl={normalizedUrl} />
          </div>
        </div>
        <ReferFriendsQRCode shareUrl={normalizedUrl} />
      </div>
    </>
  )
}
